import { render, staticRenderFns } from "./RollerBlind2.vue?vue&type=template&id=284241c2&scoped=true&"
import script from "./RollerBlind2.vue?vue&type=script&lang=js&"
export * from "./RollerBlind2.vue?vue&type=script&lang=js&"
import style0 from "./RollerBlind2.vue?vue&type=style&index=0&id=284241c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284241c2",
  null
  
)

export default component.exports